module.exports = "/assets/84c060f710ac3fac553aceaf6b35667d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DJ.png
// module id = 2430
// module chunks = 0